import PATH from "constants/path";
import React from "react";
import { formatNumber } from "utils/common";
import { LIST_SIDEBAR } from "./constant";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function Sidebar() {
  let pathname = useLocation().pathname;

  const { userDisplay: user, isInLine } = useSelector((state) => state.user);

  // get pathname in URL:
  const pathString = pathname.split("/");
  if (pathString.length > 2) {
    pathname = "/" + pathString[1];
  }

  // check link current in sidebar => change color
  const checkActiveLink = (linkList) => {
    const result = linkList.find((item) => item === pathname);
    return result ? "active" : "";
  };

  return (
    <div className="w-20 py-3">
      <div className="filter">
        <div className="filter-header">
          <div className="text-center bg-green text-white">
            <a href={PATH.SETTING}>
              <h6 className="name-ellipsis">
                {isInLine ? <span className="fs-24 align-bottom lh-8">****</span> : user && user?.name}
                <span className="ms-2 fs-10">さん</span>
              </h6>
              <span className="subtitle fw-400 sp-14">
                [ 会員番号 : {isInLine ? <span className="fs-24 align-bottom">****</span> : user && user?.id} ]
              </span>
            </a>
          </div>
          <div className="text-center bg-filter text-green">
            <a href={PATH.MY_POINT}>
              <div className="subtitle">現在保有のいつモニ ポイント</div>
              <h3 className="number pb-2">
                <span className="number-ellipsis">
                {isInLine ? '****' : formatNumber(user?.point)}
                </span>
                <span className="name-point">ポイント</span>
              </h3>
            </a>
          </div>
        </div>

        <ul className="filter-menu">
          {LIST_SIDEBAR.map((item, index) => (
            <li
              key={index}
              className={"filter-item " + checkActiveLink(item.path)}
            >
              <a href={item.path[0]} className="filter-link">
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
